import ContantUser from './contactUser.vue';
import Supplys from './supplys.vue';

export { Supplys };
export default ContantUser;
